import * as Yup from 'yup'

type ThermoSelect = 'true' | 'false' | 'none'

export const getValidationSchema = () =>
  Yup.object().shape({
    thermodiagramConform: Yup.mixed<ThermoSelect>()
      .oneOf(['true', 'false', 'none'])
      .required('Selectați o opțiune'),
    noticeNumber: Yup.number()
      .typeError('Introduceți un număr valid')
      .required('Număr aviz este obligatoriu')
      .integer('Numărul de aviz trebuie să fie întreg')
      .min(1, 'Numărul de aviz trebuie să fie pozitiv'),
    temperature: Yup.number()
      .nullable()
      .when('thermodiagramConform', {
        is: (v: ThermoSelect) => v === 'false',
        then: s =>
          s
            .typeError('Introduceți o valoare numerică')
            .required('Temperatura este obligatorie când NU e conform')
      })
  })

export const getInitialValues = () => ({
  noticeNumber: null as number | null,
  thermodiagramConform: 'none' as ThermoSelect,
  temperature: null as number | null,

  orderStatus: undefined as unknown as number,
  dsDeliveryStatus: '' as string,
  dsDeliveryStatusValue: '' as string,
  deliveryDate: null as string | null,
  deliveryHour: null as string | null
})
